<tabs-navbar [tabLinks]="tabLinks" class="flex flex-grow flex-column"></tabs-navbar>
